export default __webpack_public_path__ + "0af5045dc9deacb6c967dd444de32779.svg";